import { z } from 'zod';
import { I18nStringSchema } from '../../core/i18n';
import { EffectLevelSchema } from '../effect';
const FootprintShapeSchema = z.enum(['Object', 'Surface', 'Path']);
const FootprintPlacementSchema = z.enum([
    'Canopy',
    'Aboveground',
    'Ground',
    'Belowground'
]);
const StickerSchema = z.object({
    altText: I18nStringSchema,
    noBack: z.string(),
    withBack: z.string(),
    peeling: z.string()
});
export const RemedyCostReferenceSchema = z.object({
    key: z.string(),
    cost: z.number()
});
export const RemedyEffectReferenceSchema = z.object({
    key: z.string(),
    level: EffectLevelSchema
});
export const BaseRemedySchema = z.object({
    key: z.string(),
    nameI18n: I18nStringSchema,
    descriptionI18n: I18nStringSchema,
    footprint: z.number(),
    footprintShape: FootprintShapeSchema,
    footprintPlacement: FootprintPlacementSchema.optional(),
    capacity: z.number().min(0).optional(),
    offsiteCollecting: z.boolean(),
    stickerImg: StickerSchema,
    deprecated: z.boolean(),
    // Relations
    category: z.string(),
    budgets: z.array(RemedyCostReferenceSchema).length(2),
    effects: z.array(RemedyEffectReferenceSchema)
});
//# sourceMappingURL=remedy.js.map